import React from 'react'

import { NavLink } from 'react-router-dom'

import { SiteContext } from 'context/site-context'

import Cities from 'components/atoms/Cities'

import './index.scss'

const PopularCities = () => {
  const [ site ] = React.useContext(SiteContext)

  return (
    <div className="popular-cities-container">
      <div className="container">
        <h2>Explore more <span className="highlight">cities</span></h2>
        <div className="categories-wrapper">
          <div className="panel">
            <Cities />
          </div>
        </div>
      </div>
    </div>
  )
}

export default PopularCities
